import { render, staticRenderFns } from "./EntryMessageReservationCanceledToApplicant.vue?vue&type=template&id=2fc9f36e"
import script from "./EntryMessageReservationCanceledToApplicant.vue?vue&type=script&lang=js"
export * from "./EntryMessageReservationCanceledToApplicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports